<span class="wrapper">
    <span *ngIf="chipItem.contentLabel" class="content-label">{{chipItem.contentLabel}}: </span>
    <span class="content">{{chipItem.content}}</span>
    <button class="close-button" (click)="dismissed.emit(chipItem.item)" attr.aria-label="{{ getAltText() | async }}">
        <img class="close-icon" src="../../../../assets/icons/icon-blue-close-x.svg" alt="" />
    </button>
</span>
